import { combineReducers } from '@reduxjs/toolkit';
import { commonReducers } from 'gcs-common/slices/commonReducers';
import { clearStore } from 'gcs-common/slices/store/storeActions';
import initSlice from './slices/initSlice/initSlice';
import settingsSlice from './slices/settings/settingsSlice';

const createBaseReducers = () =>
  combineReducers({
    ...commonReducers,
    settings: settingsSlice,
    init: initSlice,
  });

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
const createRootReducer = () => (state: any, action: { type: string }) => {
  // Note: We reset the whole state to the initial-state here
  // if needed, some parts can be also ignored
  // this is based on https://stackoverflow.com/a/35641992/8029510
  if (action.type === clearStore.type) {
    // biome-ignore lint/style/noParameterAssign: Suppress parameter reassignment
    state = undefined;
  }
  return createBaseReducers()(state, action);
};

export default createRootReducer;
